import React from 'react';
import {withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import CourseStep from './course-step';
import ProfileStep from './profile-step'
import ReviewStep from './review-step'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import {AuthContext} from '../../../../context/AuthContext'
import{SnackBarContext} from '../../../../context/SnackBarContext'
import {LoaderContext} from '../../../../context/LoaderContext'
import authentication from '../../components/authentication'
import apply_online_submit from './apply-online-submit'
function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  listItem: {
    padding: theme.spacing(1, 0),
  },
  total: {
    fontWeight: 700,
  },
  title: {
    marginTop: theme.spacing(2),
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

const steps = ['Course Details', 'Profile', 'Review and Submit'];

function getStepContent(step,props,handleNext,handleBack,handleSubmit,classes) {
  switch (step) {
    case 0:
      return <CourseStep {...props} handleNext={handleNext} classes={classes}  />;
    case 1:
      return <ProfileStep  {...props} handleNext={handleNext} classes={classes}  handleBack={handleBack} />;
    case 2:
      return <ReviewStep  {...props} handleSubmit={handleSubmit} classes={classes}  handleBack={handleBack}/>;
    default:
      throw new Error('Unknown step');
  }
}


export default withRouter((props)=>{

  const authmodal=React.useContext(AuthContext)
  const snackBar=React.useContext(SnackBarContext)
  const loader=React.useContext(LoaderContext)
  return <App {...props} authmodal={authmodal} snackBar={snackBar} loader={loader} />
})
 class App extends React.Component{

constructor(props){
  super(props)
let medium_id='';
  if(props.medium_list.length===1)
  medium_id=props.medium_list[0].id
        this.state = {
            user: {
                medium_id:medium_id,
                admission_mode_id:'',
                scholarship_test_id:'',
                name: '',
                 dd:'',
                mm:'',
                yy:'',
                phase_id:props.parent_details.id



            },
        } ;
      }


      handleChange = (event) => {
          const { user } = this.state;
          user[event.target.name] = event.target.value;
          this.setState({ user });
      }


      handleSubmit = async() => {

        const  {authmodal,snackBar,loader,history}=this.props
        const {user}=this.state
        try{

  const token=authentication()
  if(!token)
      {
        authmodal.set_post_fn({post_fn:()=>apply_online_submit({user,snackBar,loader,history})})
        authmodal.show({user,snackBar,loader,history})
      }
      else{
await apply_online_submit({user,snackBar,loader,history})
}
}
catch(e){

   snackBar.show(e.message)
}

      }

  render(){

    return(
      <Checkout  handleChange={this.handleChange} handleSubmit={this.handleSubmit} state={this.state} {...this.props}/>
    )
  }
}


 function Checkout(props) {

  const classes = useStyles();
  const theme = useTheme();
   const is_big_screen = useMediaQuery(theme.breakpoints.up('md'));
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };
const {handleSubmit}=props
  return (
    <React.Fragment>

           <Stepper activeStep={activeStep} className={classes.stepper} orientation={is_big_screen?"horizontal":"vertical"}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
               </Step>
            ))}
          </Stepper>
          <React.Fragment>
            {activeStep === steps.length ? (
              <React.Fragment>
                <Typography variant="h5" gutterBottom>
                  Thank you for your order.
                </Typography>
                <Typography variant="subtitle1">
                   Your order number is #2001539. We have emailed your order confirmation, and will
                  send you an update when your order has shipped.
                </Typography>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {getStepContent(activeStep,props,handleNext,handleBack,handleSubmit,classes)}

              </React.Fragment>
            )}
          </React.Fragment>



    </React.Fragment>
  );
}
